import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_day_1_session_reveal~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_day_1_session_reveal/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_day_1_session_reveal~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_day_1_session_reveal/__b'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_day_1_session_reveal~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_day_1_session_reveal/__b'),
			},
		},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_day_1_session_reveal~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_day_1_session_reveal/__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_day_1_session_reveal~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_day_1_session_reveal/__c'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_day_1_session_reveal~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_day_1_session_reveal/__c'),
			},
		},
	},
]

export default config
